<script lang="ts">
import AroundTheClock from '../../icons/aroundTheClock.svg';
import Card from '../../icons/card.svg';
import Clock from '../../icons/clock.svg';
import Cloud from '../../icons/cloud.svg';
import Connectivity from '../../icons/connectivity.svg';
import Cost from '../../icons/cost.svg';
import Delivery from '../../icons/delivery.svg';
import Diagnose from '../../icons/diagnose.svg';
import Repair from '../../icons/repair.svg';
import Secure from '../../icons/secure.svg';
import Sensor from '../../icons/sensor.svg';
import Smiley from '../../icons/smiley.svg';
import Software from '../../icons/software.svg';
import Team from '../../icons/team.svg';
import Verified from '../../icons/verified.svg';

type Props = {
  icon: string;
  isIconWhite?: 'blue' | 'white';
};

export const xxlIconsMap = {
  aroundTheClock: AroundTheClock,
  card: Card,
  clock: Clock,
  cloud: Cloud,
  connectivity: Connectivity,
  cost: Cost,
  delivery: Delivery,
  diagnose: Diagnose,
  repair: Repair,
  secure: Secure,
  sensor: Sensor,
  smiley: Smiley,
  software: Software,
  team: Team,
  verified: Verified,
};
</script>

<script setup lang="ts">
const { isIconWhite } = defineProps<Props>();
</script>

<template>
  <component :is="xxlIconsMap[icon]" v-if="icon" :class="isIconWhite && $style.white" />
</template>

<style module lang="scss" src="./BigIcon.scss" />
